export enum EWsMsgPatterns {
  'PAYMENT_CREATED' = `response.vabs-payment-plugin.payment.create-completed`,
  'PAYMENT_UPDATED' = `response.vabs-payment-plugin.payment.status-update-completed`,
  'BALANCE_UPDATED' = `response.vabs-payment-plugin.virtual-balance.update-completed`,
  'KYB_APPROVED' = `response.kyb.approved`,
  'KYB_REJECTED' = `response.kyb.declined`,
  'DOC_UPDATED' = `response.identity-document.updated`,
}
